import {
  POST_NUTRITION_WIFA_REQUEST,
  POST_NUTRITION_WIFA_SUCCESS,
  POST_NUTRITION_WIFA_FAILED,
  FILTER_NUTRITION_WIFA_REQUEST,
  FILTER_NUTRITION_WIFA_SUCCESS,
  FILTER_NUTRITION_WIFA_FAILED,
} from '../constance/programs.constants';

const initialState = {
  loading: false,
  data: [],
  error: '',
  status: true,
  message: '',
};
export const nutritionWifaReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_NUTRITION_WIFA_REQUEST:
      return {
        ...state,
        loading: true,
        status: true,
        error: '',
        message: '',
      };
    case POST_NUTRITION_WIFA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload.error,
        status: action.payload.status,
        message: action.payload.message,
      };
    case POST_NUTRITION_WIFA_FAILED:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        message: action.payload.message,
      };
    // !filter
    case FILTER_NUTRITION_WIFA_REQUEST:
      return {
        ...state,
        loading: true,
        data: [],
        error: '',
        message: '',
      };
    case FILTER_NUTRITION_WIFA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload.error,
        status: action.payload.status,
        message: '',
      };
    case FILTER_NUTRITION_WIFA_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };

    default:
      return state;
  }
};
